import FingerprintJS, { GetResult } from '@fingerprintjs/fingerprintjs-pro';
import { convertMsToSeconds } from '../../../utils/time';
import { Environment } from '../../../environment/environment';
import { container } from '../../../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../../../utils/container/service-ids';
import { FlagNames } from '../../../utils/feature-flags/flag-names';

export class FingerprintjsWrapper {
    static fpUser: GetResult;

    static async init() {
        try {
            if (this.fpUser) {
                return true;
            }

            const now: number = convertMsToSeconds(new Date().getTime());
            if (window.app.config.fingerprint.startTestDateTs > now ||
                now > window.app.config.fingerprint.endTestDateTs) {
                console.log('Time is out of range', {
                    now: now,
                    start: window.app.config.fingerprint.startTestDateTs,
                    end: window.app.config.fingerprint.endTestDateTs
                });
                return false;
            }

            const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
            if (!ffLoader.get(FlagNames.FINGERPRINT_ENABLED).isOn() || !Environment.isLanding() ||
                window.app.config.current_entry_point !== 'site2') {
                console.log('This env or entry point not allowed or this is not landing page ');
                return false;
            }

            const fpLoading = await FingerprintJS.load({
                token: window.app.config.fingerprint.browser_token
            });
            const fpUser = await fpLoading.get();
            if (!fpUser.visitorId) {
                window.Sentry.captureException('fingerprint was not init');
                return false;
            }
            this.fpUser = fpUser;

            return true;
        } catch (exception) {
            console.log('Init fingerprint exception', exception);
            window.Sentry.captureException('Init fingerprint exception');
            return false;
        }
    }

    static async getVisitorId(): Promise<string> {
        if (await this.init()) {
            return this.fpUser.visitorId;
        } else {
            return '';
        }
    }

    static async getConfidenceScore(): Promise<number|string> {
        if (await this.init()) {
            return this.fpUser.confidence.score;
        } else {
            return '';
        }
    }

    static async visitorIsFound(): Promise<boolean|string> {
        if (await this.init()) {
            return this.fpUser.visitorFound;
        } else {
            return '';
        }
    }
}
